import { Link } from "react-router-dom";

const SingleMemberBadge = ({ container, badge, showPeriod = false, hideAvatar = false }) => {

    const getPeriodDescription = (month, year) => {
        const date = container.localeManager.moment().month(month - 1).year(year);
        return date.format("MMMM YYYY");
    };

    return (
        <div className="member-badge-card">
            <div className="member-badge-icon-wrap">
                <img src={badge.icon} className="member-badge-icon" alt="" />
            </div>
            <div className="member-badge-body">
                <span className="member-badge-title">
                    {container.localeManager.strings[`badge_${badge.badge_type}`]}
                </span>
                {!hideAvatar && (
                    <div className="member-badge-user">
                        {badge.user != null ? (
                            <>
                                <img src={badge.user.avatar_url} className="member-badge-avatar" alt="" />
                                <Link to={`/user/${badge.user.id}`} className="member-badge-username">
                                    {badge.user.name}
                                </Link>
                            </>
                        ) : (
                            <span className="text-muted fst-italic">{container.localeManager.strings.deletedUser}</span>
                        )}
                    </div>
                )}
                {badge.value != null && (
                    <span className="member-badge-value">
                        {container.localeManager.numeral(badge.value).format('0,0')} {badge.value_symbol}
                    </span>
                )}
                {showPeriod && (
                    <span className="member-badge-period">
                        {getPeriodDescription(badge.month, badge.year)}
                    </span>
                )}
            </div>
        </div>
    );
};

export default SingleMemberBadge;